// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"6383b36f","647":"883208ba"}[chunkId] + ".chunk.css";
};